// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarPanelNavigation__container-fbb035 {
  display: flex;
  flex-direction: column;
  width: var(--sidebar-navigation-width);
  box-sizing: border-box;
  border-right: 1px solid var(--base-20);
  flex-shrink: 0;
}

.SidebarPanelNavigation__content-e8f343 {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
}

.SidebarPanelNavigation__content-group-a935d8 {
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarPanelNavigation/SidebarPanelNavigation.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,sCAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,8BAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: var(--sidebar-navigation-width);\n  box-sizing: border-box;\n  border-right: 1px solid var(--base-20);\n  flex-shrink: 0;\n}\n\n.content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.content-group {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SidebarPanelNavigation__container-fbb035`,
	"content": `SidebarPanelNavigation__content-e8f343`,
	"content-group": `SidebarPanelNavigation__content-group-a935d8`,
	"contentGroup": `SidebarPanelNavigation__content-group-a935d8`
};
module.exports = ___CSS_LOADER_EXPORT___;
